export default __webpack_public_path__ + "static/media/african-american.0cc7866e.jpg";